export default __webpack_public_path__ + "static/media/AddCircleIcon.e1c5feb6.svg";